export default function (browser) { 
    const desktopBrowser = handlers[browser]
    return desktopBrowser(browser)
}

const handlers = {
   // Opera 8.0+
   opera() {
        return (navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1;
   },

   // Firefox 1.0+
   firefox() {
        return navigator.userAgent.indexOf("Firefox") != -1;
   },

   // Safari 3.0+ "[object HTMLElementConstructor]" 
   safari() {
       return navigator.userAgent.indexOf("Safari") != -1;
   },

   // Internet Explorer 6-11
   IE() {
        return navigator.userAgent.indexOf("MSIE") != -1;
   },

   chrome() {
        return navigator.userAgent.indexOf("Chrome") != -1;
   },
}

